import { USER_TEMPLATE_TYPE } from '../../constants/dashboards';

const usersInitialState = {
  events: null,
  executing: false,
  executeId: '',
};

const execute = (state = usersInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_USERS_EVENT_QUERY_SUCCESS':
      return {
        ...state,
        events: action.events,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_USERS_EVENT_QUERY_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_USERS_EVENT_QUERY':
      return {
        ...state,
        executing: true,
      };

    case 'SET_USERS_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case `SET_RESULT_${USER_TEMPLATE_TYPE}`:
      return {
        ...state,
        events: action.templateResult,
      };

    case `SET_TEMPLATE_${USER_TEMPLATE_TYPE}`:
      return {
        ...usersInitialState,
      };

    default:
      return state;
  }
};

export default execute;

export const getEvent = (state) => state.events;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
